import { CommonRouter, i18n, utils } from "@common";
import { routerPaths } from "./tool";

import Home from "./index";
import StaffAcessReview from "./componentTable/staffAcessReview/index";
import ApplicationUsage from "./componentTable/applicationUsage/index";
import auditlogs from "./componentTable/auditlogs";
import SuspiciousActivity from "./componentTable/SuspiciousActivity";
import SignInLogs from "./componentTable/SignInLogs";
import { permissionApplicationUsage, permissionAuditLogs, permissionReport, permissionSignInLogs, permissionStaffAccessReview, permissionSuspiciousActivity } from "../constant";
export default class Router extends R.Component {
    componentCreate() {
        this.bind("onChange");
    }
    onChange(router, match) {
        if (router && router.breadcrumbs) {
            let breadcrumbs = router.breadcrumbs ? utils.type.isFunction(router.breadcrumbs) ? router.breadcrumbs(match.params) : router.breadcrumbs : [];
            breadcrumbs = [{ text: i18n.get('CIS_Nav_Reporting_Entry'), icon: 'fia-file', url: routerPaths.home }, ...breadcrumbs];
            this.setBreadcrumbs(breadcrumbs);
        }
    }
    render() {
        const routers = [
            {
                path: routerPaths.home,
                component: Home,
                exact: true,
                role: () => permissionReport.read
            },
            {
                path: routerPaths.staffAcessReview,
                component: StaffAcessReview,
                exact: true,
                breadcrumbs: [{ text: i18n.get('CIS_Admin_Reporting_StaffAccessReview_Entry') }],
                role: () => permissionStaffAccessReview.read
            },
            {
                path: routerPaths.applicationUsage,
                component: ApplicationUsage,
                exact: true,
                breadcrumbs: [{ text: i18n.get('CIS_Admin_Reporting_ApplicationUsage_Entry') }],
                role: () => permissionApplicationUsage.read
            },
            {
                path: routerPaths.auditlogs,
                component: auditlogs,
                exact: true,
                breadcrumbs: [{ text: i18n.get('CIS_Admin_Reporting_AuditLogs_Entry') }],
                role: () => permissionAuditLogs.read
            },
            {
                path: routerPaths.suspiciousActivity,
                component: SuspiciousActivity,
                exact: true,
                breadcrumbs: [{ text: i18n.get('CIS_Admin_Reporting_SuspiciousActivity_Entry') }],
                role: () => permissionSuspiciousActivity.read
            },
            {
                path: routerPaths.signInLogs,
                component: SignInLogs,
                exact: true,
                breadcrumbs: [{ text: i18n.get('CIS_Admin_Reporting_Sign_inLogs_Entry') }],
                role: () => permissionSignInLogs.read
            },
        ];
        return (<CommonRouter routers={routers} onChange={this.onChange} />);
    }
}


